import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type Locales, useTonConnectUI } from '@tonconnect/ui-react';

import { useChangeAdditionalParamsMutation } from '@/api/queries/user';
import { playSound } from '@/common/lib/soundEffect';

import css from './style.module.scss';

const ChangeLanguage: React.FC = () => {
  const [changeAdditionalParams] = useChangeAdditionalParamsMutation();
  const [, setOptions] = useTonConnectUI();
  const { t, i18n } = useTranslation();
  const [code, setCode] = useState('en');
  const languagesList = [
    {
      code: 'en',
      language: 'English',
    },
    {
      code: 'ru',
      language: 'Русский',
    },
  ];

  useEffect(() => {
    const lan = localStorage.getItem('i18nextLng') || 'en';
    setCode(lan);
  }, []);

  const changeLanguage = (code: string): void => {
    playSound('buttons/light');
    changeAdditionalParams({ language: code });
    i18n.changeLanguage(code);
    setCode(code);
    setOptions({ language: code as Locales });
  };

  return (
    <main className="page">
      <div style={{ height: '80vh', padding: '170px 10px 0' }}>
        <h2 style={{ textAlign: 'center' }}>{t('Language')}</h2>
        <ul className={css.settingsList}>
          {languagesList.map((el, index) => (
            <li
              key={index}
              className={css.settingsListElement}
              onClick={() => changeLanguage(el.code)}
            >
              <span>{el.language}</span>
              {code === el.code ? (
                <svg id="icon-checkmark" viewBox="0 0 32 32" width={20}>
                  <path
                    style={{ fill: '#82e024' }}
                    d="M27 4l-15 15-7-7-5 5 12 12 20-20z"
                  ></path>
                </svg>
              ) : (
                <></>
              )}
            </li>
          ))}
        </ul>
      </div>
    </main>
  );
};

export default ChangeLanguage;
